import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=ef1c67c6&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "./Letter.vue?vue&type=style&index=0&id=ef1c67c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c67c6",
  null
  
)

export default component.exports